module.exports = " <div class=fullscreen-button ng-if=$ctrl.FullscreenManager.isFullScreen hm-tap=$ctrl.FullscreenManager.exitFullScreen()> <div class=icon-full-screen></div> </div> <div class=fullscreen-button ng-if=!$ctrl.FullscreenManager.isFullScreen hm-tap=\"$ctrl.FullscreenManager.goFullScreen(document.querySelector('.container'))\"> <div class=\"icon-full-screen inverted\"></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fullscreen-button/fullscreen-button.html
 ** module id = 65
 ** module chunks = 0
 **/